import moment from "moment"

export function getSum(total, num) {
  return total + num
}

export function customFormatter(date, format = "YYYY-MM-DD") {
  return moment(date).format(format)
}

export function lightenHex(hex, percent) {
  hex = hex.replace("#", "")

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)

  const p = percent / 100

  const newR = Math.round(r + (255 - r) * p)
  const newG = Math.round(g + (255 - g) * p)
  const newB = Math.round(b + (255 - b) * p)

  return "#" + [newR, newG, newB].map((v) => v.toString(16).padStart(2, "0")).join("")
}
